import { Button, buttonClassName } from '@/components/ui';
import { COOKIE_POLICY_HREF } from './links';

export interface CookieNoticeProps {
  onDismiss: () => void;
}

/**
 * Quando só há cookies necessários não há o que perguntar — só o que informar,
 * uma vez. Cartão discreto; "Entendi" o dispensa para sempre neste navegador.
 */
export function CookieNotice({ onDismiss }: CookieNoticeProps): JSX.Element {
  return (
    <div className="cookie-notice" role="region" aria-label="Aviso de cookies">
      <p className="cookie-notice__text">
        Usamos apenas cookies necessários ao funcionamento e às suas preferências.
      </p>
      <div className="cookie-notice__actions">
        <Button size="sm" onClick={onDismiss}>
          Entendi
        </Button>
        <a href={COOKIE_POLICY_HREF} className={buttonClassName('ghost', 'sm')}>
          Saiba mais
        </a>
      </div>
    </div>
  );
}
